<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconScreenRotation_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M19 9a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2zm-1.375 5a1.06 1.06 0 1 0 0 2.122 1.06 1.06 0 0 0 0-2.121M18.61 7.335h-3.556a.86.86 0 0 1-.634-.255.86.86 0 0 1-.256-.634.86.86 0 0 1 .256-.633.86.86 0 0 1 .634-.256h.8a5.9 5.9 0 0 0-2-1.323 6.3 6.3 0 0 0-2.357-.456 6.1 6.1 0 0 0-2.957.745 6.05 6.05 0 0 0-2.223 2.034q-.312.445-.667.512-.356.066-.667-.09a.86.86 0 0 1-.433-.466.64.64 0 0 1 .055-.6 7.9 7.9 0 0 1 2.901-2.857A7.86 7.86 0 0 1 11.496 2q1.823 0 3.458.778a7.8 7.8 0 0 1 2.767 2.2V2.89a.86.86 0 0 1 .256-.633A.86.86 0 0 1 18.61 2a.86.86 0 0 1 .634.256.86.86 0 0 1 .256.633v3.557a.86.86 0 0 1-.256.634.86.86 0 0 1-.634.255"
    />
</svg>
